import { AxiosError } from 'axios';
import useNotifications from '../use-notifications';
import { APP_SIGN_IN_PENDING } from 'src/shared/constants';
import useRouteUtils from '../../router-utils/route-utils';
import { RouteLocationNormalized, RouteRecordNormalized } from 'vue-router';
import useRouteResolverUserPreferences from '../../router-utils/route-resolver-user-preferences';
import { IRouteMeta, IRouteMetaResolveResults, ResolveParams, ResolveResult } from 'src/core/models/routing';

export default () => {
  const { showError } = useNotifications();
  const { getResolvedRoutePaths, replaceRouteParamsWithValues } = useRouteUtils();

  const resolve = async (to: RouteLocationNormalized, from: RouteLocationNormalized): Promise<boolean> => {
    let errorOccured = false;
    const allRouteResolveActionResults = new Map<RouteRecordNormalized, ResolveResult[]>();

    try {
      const resolvedRoutePaths = getResolvedRoutePaths(from);
      const { updateResolveParamsBasedOnUserPreferences } = useRouteResolverUserPreferences();

      for (const toMatchedRoute of to.matched) {
        const routeMeta = toMatchedRoute.meta as IRouteMeta;
        if (errorOccured || !routeMeta || !routeMeta.resolve) continue;

        const isAlreadyResolved = resolvedRoutePaths.includes(replaceRouteParamsWithValues(toMatchedRoute.path, to.params));
        if (isAlreadyResolved) continue;

        try {
          const resolveParams = new ResolveParams();
          resolveParams.params = { ...to.params };
          resolveParams.containerType = routeMeta.containerType;
          resolveParams.routeName = toMatchedRoute.name?.toString() || '';

          updateResolveParamsBasedOnUserPreferences(
            to,
            resolveParams,
            routeMeta.containerType,
            routeMeta.defaultDynamicFilters || []
          );

          const results = await routeMeta.resolve(resolveParams);

          let resolvePromiseResults = Array.isArray(results) ? results : [results];
          allRouteResolveActionResults.set({ ...toMatchedRoute }, resolvePromiseResults);
        } catch (e: any) {
          errorOccured = true;
          if (!isHandledSilently(e)) showError(getErrorMsg(e), 'Error');
        }
      }
      const toMeta = to.meta as IRouteMetaResolveResults;
      toMeta.isRouteCanceled = errorOccured;
      toMeta.guardResolveResults = allRouteResolveActionResults;
    } catch (e: any) {
      errorOccured = true;
      if (!isHandledSilently(e)) showError(getErrorMsg(e), 'Error');
    }

    return errorOccured;
  };

  const isHandledSilently = (e: any) =>
    e === APP_SIGN_IN_PENDING || e?.message === APP_SIGN_IN_PENDING || e === 'AUTH_SIGNIN_REDIRECT';

  const getErrorMsg = (e: any) =>
    (e as AxiosError)?.message || e?.message || 'Error while executing HTTP request! Please contact support!';

  return {
    resolve,
  };
};
